import { render, staticRenderFns } from "./SingleUpgradeKey.vue?vue&type=template&id=cdd07c14&"
import script from "./SingleUpgradeKey.vue?vue&type=script&lang=js&"
export * from "./SingleUpgradeKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd07c14')) {
      api.createRecord('cdd07c14', component.options)
    } else {
      api.reload('cdd07c14', component.options)
    }
    module.hot.accept("./SingleUpgradeKey.vue?vue&type=template&id=cdd07c14&", function () {
      api.rerender('cdd07c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SingleUpgradeKey.vue"
export default component.exports